import { useAppointmentForm, type UseAppointmentFormOptions } from './useAppointmentForm';
import CalcomLayout from './layouts/CalcomLayout';
import DoctolibLayout from './layouts/DoctolibLayout';
import './widget.css';

export interface AppointmentWidgetProps extends UseAppointmentFormOptions {
  /** Override the style chosen in form config (useful for preview) */
  styleOverride?: 'calcom' | 'doctolib';
}

export default function AppointmentWidget(props: AppointmentWidgetProps) {
  const { styleOverride, ...rest } = props;
  const state = useAppointmentForm(rest);
  const style = styleOverride || state.config?.style || 'calcom';
  if (style === 'doctolib') return <DoctolibLayout state={state} />;
  return <CalcomLayout state={state} />;
}
